import ResendEmail from './ResendEmail'
import Vue, { VNode } from 'vue'
import { validateCompanyEmail } from '@rhitics/rhitics/helpers'
import MastHead from '@rhitics/vue/components/MastHead.vue'

type VForm = Vue & {
  reset: () => void
  validate: () => boolean
  resetValidation: () => void
}

let $form: VForm

export default Vue.extend({
  name: 'Register',

  components: {
    ResendEmail,
    MastHead
  },

  data() {
    return {
      valid: false,
      error: '',
      showPassword: false,
      sucessDialog: false,
      rules: {
        required: (v: string) => !!v || 'Required',
        min: (v: string) => v.length >= 6 || 'Min 6 characters',
        email: (v: string) => validateCompanyEmail(v) || 'Incorrect email.'
      },
      form: {
        loading: false,
        name: '',
        email: '',
        password: ''
      }
    }
  },

  mounted() {
    $form = this.$refs.form as VForm
  },

  methods: {
    reset() {
      const form = this.form
      form.loading = false
      form.email = ''
      form.name = ''
      form.password = ''
    },

    async submit(event: Event) {
      event.preventDefault()
      this.valid = $form.validate()
      if (!this.valid || this.form.loading) return
      try {
        this.form.loading = true
        const { access_token } = (await this.$auth.register(this.form)).data
        this.sucessDialog = true
        this.$auth.setToken(access_token)
        this.reset()
        $form.resetValidation()
      } catch ({ response }) {
        this.error = 'Oops, Something went wrong, Please contact IT team.'
        const isValidateIssue = (response as any).status === 422
        if (isValidateIssue) {
          const isEmailIssue = Object.keys((response as any).data.errors).includes('email')
          if (isEmailIssue) {
            this.error = 'This email has already been registered.'
          }
        }
        window.setTimeout(() => (this.error = ''), 5000)
      } finally {
        this.form.loading = false
      }
    }
  },

  render(): VNode {
    const form = this.form
    const rules = this.rules
    const formView = (
      <v-form ref="form" class="mt-5" on={{ submit: this.submit }}>
        <div class="headline mb-2">Register</div>
        <v-text-field rules={[rules.required]} label="Name" type="text" v-model={form.name} />
        <v-text-field rules={[rules.required, rules.email]} label="Email" type="email" v-model={form.email} />
        <v-text-field
          rules={[rules.required, rules.min]}
          append-icon={this.showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}
          label="Password"
          type={this.showPassword ? 'text' : 'password'}
          v-model={form.password}
          on={{
            'click:append': () => (this.showPassword = !this.showPassword)
          }}
        />
        <v-row>
          <resend-email />
          <v-spacer />
          <v-btn disabled={form.loading} loading={form.loading} color="primary" type="submit">
            Submit
          </v-btn>
        </v-row>
      </v-form>
    )

    const errorAlert = (
      <v-alert class="mt-4" outlined type="error">
        {this.error}
      </v-alert>
    )

    const successPopup = (
      <v-dialog v-model={this.sucessDialog} width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Verify Email.
          </v-card-title>
          <v-card-text>Rhitics will send a verify mail to you. Please check the mail in 30 minutes.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <a target="_blank" href="https://gmail.com">
              Open Gmail
            </a>
          </v-card-actions>
        </v-card>
      </v-dialog>
    )

    return (
      <v-app>
        <mast-head />
        <v-content>
          <v-container grid-list-md>
            <v-row row wrap>
              <v-col xs="12" md="6">
                此頁面已移除, 請聯絡 RHITICS Team 協助申請帳號
                {this.error ? errorAlert : null}
              </v-col>
            </v-row>
            {successPopup}
          </v-container>
          <router-view />
        </v-content>
      </v-app>
    )
  }
})
